import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';
import {
  CommissionsByMonthQueryResponse,
  UseCommissionsByMonthQueryParams,
} from './useCommissionsByMonth.types';

const PREFIX = '[allCommissionsByMonthQuery]';

export const allCommissionsByMonthQuery = async (params: UseCommissionsByMonthQueryParams) => {
  console.log(PREFIX, `Fetching commissions...`);
  const response = await COMMERCIAL_ENDPOINTS.getAllCommissionsByMonth(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commissions.`);
  return json as CommissionsByMonthQueryResponse;
};
